export const SUBSCRIPTION_QUERY_KEY = [
  "subscription",
] as const;
